/**
 * 纯 Web Audio 声音合成器 (原生无依赖)
 * 提供 5 种微音效：click, recall, success, error, win
 */

let muted = false

export function setMuted(val: boolean) {
    muted = val
}

export function isMuted(): boolean {
    return muted
}

function tone(freqs: number[], dur = 0.12, type: OscillatorType = "sine", gap = 0.08) {
    if (muted) return
    try {
        const AudioContextClass = window.AudioContext || (window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext
        if (!AudioContextClass) return
        const ctx = new AudioContextClass()
        freqs.forEach((f, i) => {
            const o = ctx.createOscillator()
            const g = ctx.createGain()
            o.type = type
            o.frequency.value = f
            const t = ctx.currentTime + i * gap
            g.gain.setValueAtTime(0.18, t)
            g.gain.exponentialRampToValueAtTime(0.001, t + dur)
            o.connect(g).connect(ctx.destination)
            o.start(t)
            o.stop(t + dur)
        })
    } catch {
        // 移动端静音降级容错
    }
}

export const sfx = {
    click: () => tone([620], 0.06, "triangle"),
    recall: () => tone([380], 0.06, "sine"),
    success: () => tone([880, 1175, 1568], 0.5, "sine", 0.09),
    error: () => tone([140], 0.18, "square"),
    win: () => tone([523, 659, 784, 1046, 1318], 0.7, "triangle", 0.12),
}
